import { render, staticRenderFns } from "./Qtrk.vue?vue&type=template&id=27cfb744&scoped=true&"
import script from "./Qtrk.vue?vue&type=script&lang=js&"
export * from "./Qtrk.vue?vue&type=script&lang=js&"
import style0 from "./Qtrk.vue?vue&type=style&index=0&id=27cfb744&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cfb744",
  null
  
)

export default component.exports